import SlideObjectQuestions from './SlideObjectQuestions';

export default SlideObjectQuestions;
